import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=241e67f7"
import script from "./Measurements.vue?vue&type=script&lang=js"
export * from "./Measurements.vue?vue&type=script&lang=js"
import style0 from "./Measurements.vue?vue&type=style&index=0&id=241e67f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports